import * as React from 'react';
import { view } from '@risingstack/react-easy-state';
import { confirmDialogStore } from 'stores/confirmDialog';
import { ConfirmationModalFn } from '../ui/ConfirmationModal/ConfirmationModal';
import { useModal } from '../ui/Modal/useModal';

const CONFIRM_DIALOG_MODAL_NAME = 'confirmDialogGlobal';

export const ConfirmDialogStore = view(() => {
  const { openModal, closeModal } = useModal(CONFIRM_DIALOG_MODAL_NAME);

  React.useEffect(() => {
    if (confirmDialogStore.pending) {
      openModal();
    } else {
      closeModal();
    }
  }, [confirmDialogStore.pending]);

  if (!confirmDialogStore.pending) return null;

  return (
    <ConfirmationModalFn
      {...confirmDialogStore.pending}
      name={CONFIRM_DIALOG_MODAL_NAME}
    />
  );
});
